const footerHeight = 72;

export default footerHeight;
